import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EmptyBodyInterceptor } from './interceptors/empty-body.interceptor';
import { ShivaPrivateInterceptor } from './interceptors/shiva-private.interceptor';
import { ShivaPublicInterceptor } from './interceptors/shiva-public.interceptor';

export const provideHttpCore = () => [
  provideHttpClient(withInterceptorsFromDi()),
  { provide: HTTP_INTERCEPTORS, useClass: EmptyBodyInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ShivaPublicInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ShivaPrivateInterceptor, multi: true },
];
